// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1y274","header":"PatientQuestionnaire_header__1DEU9","info":"PatientQuestionnaire_info__1IEUL"};